import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import { runInAction } from 'mobx';
import { ScoreDetailService } from '../../../../../common/services';
import TeamGameStatModel from './model/teamGameStat';
import { ObjectUtil } from '../../../../../common/utils/objectUtil';
import { _COMPARISON_CHART_INIT } from './constants';

const SoccerMatchRecordStore = () => {
  const store = useLocalStore(() => ({
    teamGameStat: {
      home: {},
      away: {},
    },
    loading: true,
    init: false,
    gameId: null,
    async getTeamGameStat(sportsType, gameId) {
      const result = await ScoreDetailService.getTeamGameStatBySportsType(sportsType, gameId);
      return result;
    },
    getAll: async (sportsType, gameId) => {
      store.loading = true;

      try {
        const [teamGameStat] = await Promise.all([store.getTeamGameStat(sportsType, gameId)]);
        runInAction(() => {
          store.teamGameStat = {
            home: new TeamGameStatModel(teamGameStat.home, 'home'),
            away: new TeamGameStatModel(teamGameStat.away, 'away'),
          };

          store.loading = false;
        });
      } catch (e) {
        store.loading = false;
      }
    },
    get comparisonChart() {
      const { teamGameStat } = store;
      const { home, away } = teamGameStat;

      let result = ObjectUtil.deepClone(_COMPARISON_CHART_INIT);

      if (!!home.chart && !!away.chart) {
        Object.keys(_COMPARISON_CHART_INIT).forEach((key) => {
          result[key] = {
            home: home.chart[key],
            away: away.chart[key],
            visible: false,
          };

          if (result[key]['home'].p > 0 || result[key]['away'].p > 0) {
            const homeP = result[key]['home'].p;
            const awayP = result[key]['away'].p;

            result[key]['home']['active'] = false;
            result[key]['away']['active'] = false;
            result[key]['visible'] = true;

            if (homeP > awayP) {
              result[key]['home']['active'] = true;
            } else {
              result[key]['away']['active'] = true;
            }

            if (homeP === awayP) {
              result[key]['home']['active'] = false;
              result[key]['away']['active'] = false;
            }

            if (result[key]['home'].v === result[key]['away'].v) {
              result[key]['home']['active'] = false;
              result[key]['away']['active'] = false;
            }
          }
        });
      }

      return result;
    },
  }));

  return {
    getAll: store.getAll,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        teamGameStat: store.teamGameStat,
        comparisonChart: store.comparisonChart,
      };
    }),
  };
};

export default SoccerMatchRecordStore;
